<template>
  <div class="voyage-summary">
    <div>
      <v-icon class="icon-style" small>mdi-calendar</v-icon>
      <span class="value-style">
        {{ voyage.startTimeStamp }} - {{ voyage.startDate }}
      </span>
    </div>

    <div>
      <v-icon class="icon-style" small :color="displayStatusColor">
        {{ displayIcon }}
      </v-icon>
      <span class="value-style">
        {{ displayStatus }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoyageInfoSummary",
  props: {
    voyage: Object,
  },
  computed: {
    displayStatus() {
      if (this.voyage.status == "state.task.completed") {
        return "Completed";
      } else if (this.voyage.status.includes("error")) {
        return "Failed";
      } else {
        return "Running";
      }
    },
    displayStatusColor() {
      if (this.voyage.status == "state.task.completed") {
        return "green";
      } else if (this.voyage.status.includes("error")) {
        return "red";
      } else {
        return "blue";
      }
    },
    displayIcon() {
      if (this.voyage.status == "state.task.completed") {
        return "mdi-check";
      } else if (this.voyage.status.includes("error")) {
        return "mdi-close";
      } else {
        return "mdi-clock";
      }
    },
  },
};
</script>

<style scoped>
.voyage-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: row;
  flex-wrap: wrap;
}
.value-style {
  font-size: 12px;
  color: var(--color-text);
}
.icon-style {
  color: var(--color-text) !important;
}
</style>

